import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterSelect, sortSelect } from "../../features/Filter/filterSlice";

export default function AsideMenu({ blogs = [] }) {
  const { sort, filter } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  const [selectValue, setSelectValue] = useState(sort);
  const [radioValue, setRadioValue] = useState(filter);

  const handleSelectChange = (event) => {
    setSelectValue(event.target.value);
    dispatch(sortSelect(event.target.value));
  };

  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
    dispatch(filterSelect(event.target.value));
  };
  return (
    <>
      <aside>
        <div className="sidebar-items">
          <div className="sidebar-content">
            <h4>Sort</h4>
            <select
              name="sort"
              id="lws-sort"
              className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
              value={selectValue}
              onChange={handleSelectChange}
            >
              <option value="">Default</option>
              <option value="newest">Newest</option>
              <option value="most_liked">Most Liked</option>
            </select>
          </div>
          <div className="sidebar-content">
            <h4>Filter</h4>
            <div className="radio-group">
              {/* <!-- handle filter on button click --> */}
              <div>
                <input
                  type="radio"
                  name="filter"
                  id="lws-all"
                  // checked
                  className="radio"
                  value="All"
                  checked={radioValue === "All"}
                  onChange={handleRadioChange}
                />
                <label htmlFor="lws-all">All</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="filter"
                  id="lws-saved"
                  className="radio"
                  value="saved"
                  checked={radioValue === "saved"}
                  onChange={handleRadioChange}
                />
                <label htmlFor="lws-saved">Saved</label>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
